// extracted by mini-css-extract-plugin
export var chevron = "_ji-4";
export var chevronExpanded = "_ji-5";
export var row = "_ji-0";
export var rowBody = "_ji-6";
export var rowDescription = "_ji-7";
export var rowHeader = "_ji-1";
export var rowTitle = "_ji-2";
export var rowTitleComplete = "_ji-3";